  <template>
  <div class="dataloggerManage">
    <div class="section" v-if="dataloggerPageValue==1">
      <div class="search">
        <div class="searchLeft">
          <button class="button-solid button buttonDeviceJurisdiction"  @click="multiBind()">
              {{ $t('datalogger.batchAddScq') }}
            <span class="iconfont icon-add"></span>
          </button>
          <button style="margin-left: 10px;" class="button-solid button buttonDeviceJurisdiction"  @click="multiEdit()">
            {{ $t('datalogger.batch_edit_datalogger') }}
            <span class="iconfont icon-add"></span>
          </button>
        </div>
        <div class="searchRight">
          <!-- 搜索 -->
          <div class="adminSearch">
            <el-input
              class="searchAll"
              ref="iptFocus"
              v-model.trim="search.search"
              @keyup.enter.native="getDataloggerList(true)"
              :placeholder="this.$t('datalogger.Ple_PN')"
              clearable
            ></el-input>
            <!-- 搜索 -->
            <span class="search-device" @click="getDataloggerList(true)">{{ $t('recharge.Search') }}</span>
            <!-- 取消 -->
            <!-- <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span> -->
          </div>
        </div>
      </div>
      <el-table
        :data="dataloggerList"
        border
        stripe
        height="100%"
        :row-style="{ height: 0 }"
        :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        v-loading="loadingDatalogger"
        element-loading-spinner="el-icon-loading"
        class="tablemain tableloding"
      >
        <el-table-column min-width="140px;" :show-overflow-tooltip="true" label="PN">
          <template slot-scope="scope">
            <span 
              :class="{'redirect':scope.row.pn}"
              @click="debugDatalogger(scope.row)"
            :title="scope.row.pn">{{scope.row.pn }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="this.$t('device.coll_alias')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.alias">{{scope.row.alias ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="140px;"
          :show-overflow-tooltip="true"
          :label="this.$t('account.accountName')"
        >
          <template slot-scope="scope">
            <span
              :class="{'redirect':scope.row.usr}"
              @click="enterAccount(scope.row)"
              :title="scope.row.usr"
            >{{scope.row.usr ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.frequency')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.dat_fetch">{{scope.row.dat_fetch ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.heartbeat')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.heartbeat">{{scope.row.heartbeat ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.start_address')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.devaddr_min">{{scope.row.devaddr_min ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.deadline_address')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.devaddr_max">{{scope.row.devaddr_max ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.timeZone')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.timezone">{{scope.row.timezone ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.warehousing_time')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.gts">{{scope.row.gts ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
   :label="this.$t('datalogger.collector_expire_time')" >
          <template slot-scope="scope">
            <span :title="scope.row.termDate">{{scope.row.termDate ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100px;"
          :show-overflow-tooltip="true"
          :label="this.$t('datalogger.collection_cycle')"
          
        >
          <template slot-scope="scope">
            <span :title="scope.row.dataStorageTime">{{scope.row.dataStorageTime ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="this.$t('device.Operation')"
          width="210px"
          class="fixedRgiht"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('device.detail')"
              @click="viewDatalogger(scope.row)"
            >
              <i class="iconfont icon-a-mingchengyanjing1"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('device.edit')"
              @click="editDatalogger(scope.row)"
            >
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('device.debug')"
              @click="debugDatalogger(scope.row)"
            >
              <i class="iconfont icon-caozuo_tiaoshi"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('datalogger.reset')"
              @click="resetDatalogger(scope.row.pn)"
            >
              <i class="iconfont icon-a-mingchengzhongzhiyangshidansexianxingtubiao1"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('datalogger.unbind')"
              @click="unbindDatalogger(scope.row.pn)"
            >
              <i class="iconfont icon-a-mingchengyonghushuxingshanchu2"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class style="margin-left:16px;"></span>
        <el-pagination
          class="pagination"
          background
          @size-change="getDataloggerList(true)"
          @current-change="() => getDataloggerList()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <debugDatalogger  @noticeDataloggerBox="showDataloggerListBox" :dataloggerListParamPN="dataloggerListParamPN"  v-if="dataloggerPageValue==2" ></debugDatalogger>
    <!-- 编辑数采器 -->
    <control-dialog
      :title="$t('datalogger.editDataloggerName')"
      :class="{ 'showDialog': editDataloggerVisible, 'hideDialog': !editDataloggerVisible }"
      :visible.sync="editDataloggerVisible"
      noFooter
    >
      <el-form
        ref="editForm"
        :model="dataLoggerData"
        slot="content"
        class="bianji grid"
        element-loading-spinner="el-icon-loading"
      >
        <el-form-item :label="$t('datalogger.Datalogger_PN')">
          <el-input v-model="dataLoggerData.pn" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('device.upgrade_brate')" prop="baudrate">
          <el-input
            clearable
            type="text"
            v-model="dataLoggerData.baudrate"
            :placeholder="$t('strategy.strategy_baudrate')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.min_addr')" prop="devaddrMin">
          <el-input clearable v-model="dataLoggerData.devaddrMin" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.max_addr')" prop="devaddrMax">
          <el-input clearable v-model="dataLoggerData.devaddrMax" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.transmission')" prop="transMode">
          <el-select
            v-model="dataLoggerData.transMode"
            placeholder
            popper-class="select-search-recharge"
          >
            <el-option
              v-for="item in transmissionList"
              :key="item.num"
              :value="item.num"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('datalogger.transparent_set')" prop="protocols">
          <el-input clearable v-model="dataLoggerData.protocols" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.frequency')" prop="datFetch">
          <el-input clearable v-model="dataLoggerData.datFetch" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.devcode')" prop="vcode">
          <el-input clearable v-model="dataLoggerData.vcode" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.protocol_code')" prop="pvcode">
          <el-input clearable v-model="dataLoggerData.pvcode" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.domain_name')" prop="domain">
          <el-input clearable v-model="dataLoggerData.domain" auto-complete="off"></el-input>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <button
            type="button"
            class="btn btn-dark"
            @click="editDataloggerConfirm"
          >{{ $t('account.confirm') }}</button>
        </div>
      </el-form>
    </control-dialog>
    <!--重置数采器-->
    <control-dialog
      :title="$t('datalogger.resetDataloggerName')"
      :class="{ 'showDialog': resetDataloggerVisible, 'hideDialog': !resetDataloggerVisible }"
      :visible.sync="resetDataloggerVisible"
      noFooter
    >
      <div slot="content">
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.resetTitle1') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.resetDataloggerPn }}</span>
        </div>
        <!-- <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode"
        :placeholder="$t('datalogger.resetTitle')"></el-input>-->
        <div style="text-align:right;">
          <button
            class="btn btn-light"
            style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="resetDataloggerVisible = false;"
          >{{ $t('datalogger.cancel') }}</button>
          <button
            style="background:#DD6843;"
            class="btn btn-dark"
            @click="resetDataloggerConfirm()"
          >
            {{
            $t('datalogger.reset') }}
          </button>
        </div>
      </div>
      <div slot="footer"></div>
    </control-dialog>
    <!--解绑数采器-->
    <control-dialog
      :title="$t('datalogger.unbindDataloggerName')"
      :class="{ 'showDialog': unbindDataloggerVisible, 'hideDialog': !unbindDataloggerVisible }"
      :visible.sync="unbindDataloggerVisible"
      noFooter
    >
      <div slot="content">
        <div style="font-size:16px;color:#DD6843;">{{ $t('datalogger.unbingTitle') }}</div>
        <div style="color:#D9E2E6;font-size:14px;margin:10px 0 20px;">
          <span>{{ $t('recharge.DataloggerPN') }}</span>
          <span>{{ this.resetDataloggerPn }}</span>
        </div>
        <!-- <el-input style="margin-bottom:30px;" v-model="resetDataloggerCode"
        :placeholder="$t('datalogger.unbindTitle')"></el-input>-->
        <div style="text-align:right;">
          <button
            class="btn btn-light"
            style="margin-right:10px;color:#DD6843;border:1px solid #DD6843 "
            @click="unbindDataloggerVisible = false;"
          >{{ $t('device.cancel') }}</button>
          <button
            style="background:#DD6843;"
            class="btn btn-dark"
            @click="unbindDataloggerConfirm()"
          >
            {{
            $t('datalogger.unbind') }}
          </button>
        </div>
      </div>
      <div slot="footer"></div>
    </control-dialog>
    <!-- 查看数采器信息 -->
    <control-dialog
      :title="$t('datalogger.dataloggerView')"
      width="80vw"
      :class="{ 'showDialog': viewDataloggerVisible, 'hideDialog': !viewDataloggerVisible }"
      :visible.sync="viewDataloggerVisible"
      noFooter
    >
      <div slot="content">
        <el-table
          :data="viewDataloggerVal"
          stripe
          border
          height="100%"
          :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
          element-loading-spinner="el-icon-loading"
          class="tablemain tableloding"
          :empty-text="$t('account.nodata')"
        >
          <el-table-column
            min-width="140px;"
            :show-overflow-tooltip="true"
            :label="$t('datalogger.describe')"
            prop="name"
          >
            <template slot-scope="scope">
              <span>{{scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="140px;"
            :show-overflow-tooltip="true"
            :label="$t('datalogger.field_name')"
            prop="key"
          >
            <template slot-scope="scope">
              <span>{{scope.row.key ||"--"}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="140px;"
            :show-overflow-tooltip="true"
            :label="$t('datalogger.checkVal')"
            prop="val"
          >
            <template slot-scope="scope">
              <span>{{scope.row.val ||"--"}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </control-dialog>
    <!-- 批量添加数采器 -->
    <control-dialog :title="$t('datalogger.batchAddScq')"
      :class="{ 'showDialog': dialogAdd, 'hideDialog': !dialogAdd }" :visible.sync="dialogAdd" width="800px"
      noFooter>
      <div slot="content">
          <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileExcelUploader.click()">
                  <i class="iconfont icon-shangchuan1"></i>
              </button>
              <div class="upload-tip">{{ $t('datalogger.upload_tips') }}</div>
              <input type="file" class="upload-input" ref="fileExcelUploader"
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @change="uploadfile($event)" />
          </div>
          <div class="uploadTips">
             <div style="font-size:14px;color:#F56C6C;" class="upload-tip">{{ $t('datalogger.upload_column_tips') }}</div>
             <img style="width: 400px;height: 142px;" src="@/assets/img/batchAddCollectors.png" alt="">
             <!-- <img v-if="this.$lang.currentLang == 'zh_CN'" src="@/assets/img/batchAddCollectors.png" alt="">
             <img v-else src="@/assets/img/importPnExampleUs.png" alt=""> -->
          </div>
      </div>
    </control-dialog>
    <control-dialog :title="$t('datalogger.batch_edit_datalogger')"
      :class="{ 'showDialog': dialogEdit, 'hideDialog': !dialogEdit }" :visible.sync="dialogEdit" width="800px"
      noFooter>
      <div slot="content">
          <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileExcelUploaderEdit.click()">
                  <i class="iconfont icon-shangchuan1"></i>
              </button>
              <div class="upload-tip">{{ $t('datalogger.upload_csv_tips') }}</div>
              <input type="file" class="upload-input" ref="fileExcelUploaderEdit"
                  accept=".csv"
                  @change="uploadfileEdit($event)" />
          </div>
          <div class="uploadTips" @click="previewImg('@/assets/img/batchEditCollectors.png')">
             <div style="font-size:14px;color:#F56C6C;" class="upload-tip">{{ $t('datalogger.click_enlarge') }}</div>
             <img style="width: 100%;height: 142px;" src="@/assets/img/batchEditCollectors.png" alt="">
          </div>
      </div>
    </control-dialog>
      <el-dialog
  :visible.sync="previewImgVisible"
  width="auto"
  class="img-preview-dialog"
  :show-close="false"
  center>
  <img :src="previewImgUrl" alt="" style="max-width:90vw;max-height:80vh;display:block;margin:auto;">
</el-dialog>
  </div>
</template>
<script>
// import dataloggerDialog from "@/components/dialognew/dataloggernew";
import controlDialog from "@/components/dialognew";
import debugDatalogger from "./dataloggerInfo";
import Vue from "vue";
import { mapGetters } from "vuex";
export default {
  components: {
    // dataloggerDialog,
    controlDialog,
    debugDatalogger
  },
  data() {
    return {
      previewImgVisible: false,
      previewImgUrl: '',
      dialogEdit: false,
      dataloggerListParamPN:'',
      dataloggerPageValue: 1,
      dialogAdd: false,
      search: {
        search: ""
      },
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      loadingDatalogger: false,
      dataloggerList: [],
      // 搜索弹出
      showSearch: false,
      // 重置数采器弹框
      resetDataloggerVisible: false,
      // 重置数采器
      resetDataloggerPn: "",
      resetDataloggerCode: "",
      // 解绑数采器
      unbindDataloggerVisible: false,
      // 编辑数采器弹框
      editDataloggerVisible: false,
      // 查看数采器弹框
      viewDataloggerVisible: false,
      viewDataloggerVal: [
        { name: "数采器PN号", key: "pn", val: "" },
        { name: "厂家编码", key: "vcode", val: "" },
        { name: "数采器别名", key: "alias", val: "" },
        { name: "所属电站业主id", key: "uid", val: "" },
        { name: "所属电站id", key: "pid", val: "" },
        { name: "所属分销商id", key: "did", val: "" },
        { name: "数据获取频率", key: "datFetch", val: "" },
        { name: "心跳间隔", key: "heartBeat", val: "" },
        { name: "是否已注册", key: "reg", val: "" },
        { name: "时区(秒)	", key: "timezone", val: "" },
        { name: "轮询最小地址", key: "devaddrMin", val: "" },
        { name: "轮询最大地址", key: "devaddrMax", val: "" },
        { name: "带载数", key: "load", val: "" },
        { name: "强制设备协议", key: "devcode", val: "" },
        { name: "组", key: "group", val: "" },
        { name: "数采器状态", key: "status.status", val: "" },
        { name: "最后上线", key: "status.lastAttach", val: "" },
        { name: "最后离线", key: "status.lastDetach", val: "" },
        { name: "最后心跳", key: "status.lastHeartBeat", val: "" },
        { name: "GPRS-CCID", key: "gprs.ccid", val: "" },
        { name: "卡号", key: "gprs.card", val: "" },
        { name: "IMSI", key: "gprs.IMSI", val: "" },
        { name: "套餐激活日期(八时区)", key: "gprs.adate", val: "" },
        { name: "套餐失效日期(八时区)", key: "gprs.edate", val: "" },
        {
          name: "最后更新套餐激活/失效日期的时间戳(零时区)",
          key: "gprs.lts",
          val: ""
        },
        { name: "入库时间(0时区)", key: "gts", val: "" }
      ],
      // 数采器数据
      dataLoggerData: {
        baudrate: "",
        pn: "",
        devaddrMin: "",
        devaddrMax: "",
        transMode: "",
        protocols: "",
        datFetch: "",
        vcode: "",
        pvcode: "",
        domain: "",
        i18n: ""
      },
      // 透传标识下拉列表
      transmissionList: [
        {
          num: 2,
          label: this.$t("datalogger.transmission2"),
          name: "透传"
        },
        {
          num: 0,
          label: this.$t("datalogger.transmission1"),
          name: "本地"
        }
      ]
    };
  },
  computed: {
    // 时区过滤
    filterTimeZone() {
      return val => (this.zoneList[val] ? this.zoneList[val].name : "--");
    }
  },
  watch: {},
  created() {
    this.getDataloggerList();
  },
  methods: {
      previewImg(url) {
    this.previewImgUrl = require('@/assets/img/batchEditCollectors.png'); // 静态资源用 require
    this.previewImgVisible = true;
  },
    multiBind() {
        this.dialogAdd = true;
        // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
        this.$nextTick(() => {
            this.$refs.fileExcelUploader.value = null;
        });
    },
    multiEdit(){
       this.dialogEdit = true;
        // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
        this.$nextTick(() => {
            this.$refs.fileExcelUploaderEdit.value = null;
        });
    },
    //批量添加数采器
     uploadfile(event) {
        // this.$refs.upload.clearFiles()
        let file = event.target.files[0];
        if (file.size > 8 * 1024 * 1024) {
            this.$message.error(this.$t("createPlant.fileExceed"));
            return;
        }
        let suffix = file.name.split(".").slice(-1)[0];
        if (suffix !== "xlsx" && suffix !== "xls") {
            this.$message.error(this.$t("datalogger.upload_err"));
            return;
        }
        this.$request.uploadCollector(file, { action: 'adminAddCollectors', i18n: this.$lang.currentLang }).then(res => {
        if (res.err === 0) {
          if (res.dat) {
            this.$message.success(this.$t("createPlant.uploadSuccess"));
            let params = {
              action: "downLoadFile",
              id: res.dat,
              i18n: this.$lang.currentLang,
            }
            if (res.err) {
              this.$message.error(this.$t(`errCode.${res.err}`));
              return;
            } else {
              window.location.href = this.$request.http_download_url_new(params)
              this.dialogAdd = false
              this.getDataloggerList()
              setTimeout(() => { this.$message.success(this.$t("report.download")) }, 2000)
            }
          }else{
            this.dialogAdd = false
            this.$message.success(this.$t("firmware.limit3"));
          }
          // this.$message.success(this.$t("report.download"));
          // this.$message.success(this.$t("createPlant.uploadSuccess"));
          // this.getData();
          // 关闭二次弹窗
        } else if (res.err === 6) {
          this.$message.error(this.$t("firmware.limit1"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        //清除上次所传文件
        event.target.value = ''
      });
    },
    uploadfileEdit(event){
        let file = event.target.files[0];
        // if (file.size > 8 * 1024 * 1024) {
        //     this.$message.error(this.$t("createPlant.fileExceed"));
        //     return;
        // }
        let suffix = file.name.split(".").slice(-1)[0];
        if (suffix !== "csv") {
            this.$message.error("只能上传'csv'文件");
            return;
        }
        this.$request.uploadCollector(file, { action: 'updateCollectorByCsv', i18n: this.$lang.currentLang }).then(res => {
        if (res.err === 0) {
          this.$message.success(this.$t("createPlant.uploadSuccess"));
          this.dialogEdit = false
          this.getDataloggerList()
          // 关闭二次弹窗
        } else if (res.err === 6) {
          this.$message.error(this.$t("firmware.limit1"));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        //清除上次所传文件
        event.target.value = ''
      });
    },
    // 数采器列表数据
    getDataloggerList(reset) {
      this.loadingDatalogger = true;
      if (reset) this.pagination.currentPage = 1;
      let params = {
        pn: this.search.search,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        i18n: this.$lang.currentLang
      };
      this.$request
        .get("adminQueryCollectors", params)
        .then(res => {
          this.loadingDatalogger = false;
          if (res.err == 0) {
            this.dataloggerList = res.dat.item;
            this.pagination.total = res.dat.totalCount;
          } else {
            this.dataloggerList = [];
            this.pagination.total = 0;
          }
        })
        .catch(err => {
          this.loadingDatalogger = false;
          this.dataloggerList = [];
          this.pagination.total = 0;
        });
    },
    // 查看数采器信息
    viewDatalogger(info) {
      this.viewDataloggerVal = [
        { name: "数采器PN号", key: "pn", val: "" },
        { name: "厂家编码", key: "vcode", val: "" },
        { name: "数采器别名", key: "alias", val: "" },
        { name: "所属电站业主id", key: "uid", val: "" },
        { name: "所属电站id", key: "pid", val: "" },
        { name: "所属分销商id", key: "did", val: "" },
        { name: "数据获取频率", key: "datFetch", val: "" },
        { name: "心跳间隔", key: "heartBeat", val: "" },
        { name: "是否已注册", key: "reg", val: "" },
        { name: "时区(秒)	", key: "timezone", val: "" },
        { name: "轮询最小地址", key: "devaddrMin", val: "" },
        { name: "轮询最大地址", key: "devaddrMax", val: "" },
        { name: "带载数", key: "load", val: "" },
        { name: "强制设备协议", key: "devcode", val: "" },
        { name: "组", key: "group", val: "" },
        { name: "数采器状态", key: "status.status", val: "" },
        { name: "最后上线", key: "status.lastAttach", val: "" },
        { name: "最后离线", key: "status.lastDetach", val: "" },
        { name: "最后心跳", key: "status.lastHeartBeat", val: "" },
        { name: "GPRS-CCID", key: "gprs.ccid", val: "" },
        { name: "卡号", key: "gprs.card", val: "" },
        { name: "IMSI", key: "gprs.IMSI", val: "" },
        { name: "套餐激活日期(八时区)", key: "gprs.adate", val: "" },
        { name: "套餐失效日期(八时区)", key: "gprs.edate", val: "" },
        {
          name: "最后更新套餐激活/失效日期的时间戳(零时区)",
          key: "gprs.lts",
          val: ""
        },
        { name: "入库时间(0时区)", key: "gts", val: "" }
      ];

      let param = {
        pn: info.pn,
        i18n: this.$lang.currentLang
      };
      this.viewDataloggerVisible = true;
      this.$request.get("adminQueryCollectorsAllFields", param).then(res => {
        if (res.err == 0) {
          this.viewDataloggerVal.forEach(item => {
            if (item.key.indexOf(".") > -1) {
              let keys = item.key.split(".");
              let data = res.dat;
              keys.forEach(v => {
                data = data[v];
              });
              item.val = data;

              if (
                item.key == "status.lastAttach" ||
                item.key == "status.lastDetach"
              ) {
                item.val = data.ts;
              }
            } else {
              item.val = res.dat[item.key];
            }
          });
        }
      });
    },
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
      this.search.search = "";
      this.getDataloggerList();
    },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 跳转用户
    enterAccount(info) {
      if (info.usr) {
        this.$request
          .get("applyBrowsePermission", { uid: info.uid })
          .then(res => {
            if (res.err === 0) {
              let routeUrl = this.$router.resolve({
                path: "/home",
                query: {
                  secret: res.dat.secret,
                  token: res.dat.token,
                  role: res.dat.role,
                  pprAuth: res.dat.pprAuth,
                }
              });
              window.open(routeUrl.href, "_blank");
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      } else {
        this.$message.error(this.$t("datalogger.title_usr"));
      }
    },
    // 重置数采器弹窗
    resetDatalogger(info) {
      this.resetDataloggerVisible = true;
      this.resetDataloggerPn = info;
    },
    // 确定重置数采器
    resetDataloggerConfirm() {
      this.resetDataloggerVisible = false;
      let param = {
        pn: this.resetDataloggerPn,
        level: 3
      };
      this.$request.get("adminCollectorReset", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t(`datalogger.resetSuc`));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 解绑数采器弹窗
    unbindDatalogger(info) {
      this.unbindDataloggerVisible = true;
      this.resetDataloggerPn = info;
    },
    // 确定解绑数采器
    unbindDataloggerConfirm() {
      this.unbindDataloggerVisible = false;
      let param = {
        pn: this.resetDataloggerPn,
        did: "0"
      };
      this.$request.get("adminEditCollector", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t(`datalogger.unbindSuc`));
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 编辑数采器弹窗
    editDatalogger(info) {
      this.editDataloggerVisible = true;
      Object.assign(this.$data.dataLoggerData,this.$options.data.call(this).dataLoggerData)
      this.dataLoggerData.baudrate = info.baudrate;
      this.dataLoggerData.pn = info.pn;
      this.dataLoggerData.devaddrMin = info.devaddr_min;
      this.dataLoggerData.devaddrMax = info.devaddr_max;
      this.dataLoggerData.transMode = info.transMode;
      this.dataLoggerData.protocols = info.protocols;
      this.dataLoggerData.datFetch = info.dat_fetch;
      this.dataLoggerData.vcode = info.vcode;
      this.dataLoggerData.pvcode = info.pvcode;
      this.dataLoggerData.domain = info.domain;
      this.dataLoggerData.i18n = this.$lang.currentLang;
    },
    // 编辑数采器提交
    editDataloggerConfirm() {
      let params = this.dataLoggerData;
      this.$request.get("adminEditCollectorInfo", params).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("project.editSuc"));
          this.getDataloggerList();
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        this.editDataloggerVisible = false;
      });
    },
    //  数采器调试子组件传参获取
      showDataloggerListBox (val) {
      this.dataloggerPageValue =val
    },
    // 父组件跳转到数采器调试传参
    debugDatalogger(info) {
      this.dataloggerPageValue = 2;
      this.dataloggerListParamPN =info.pn
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;
  .redirect {
    color: @primaryTextColor;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }
  .tableloding {
    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, 0.5);
    }

    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }
  }

  .tablemain {
    border: none;
    background-color: rgb(34, 45, 53);

    .operation i {
      color: @primaryTextColor;
    }

    .operation1 i {
      color: @primaryColorTransparency30;
    }

    /deep/.el-table__header th {
      height: 48px;
    }

    /deep/.el-table__header th.is-leaf {
      border-color: rgba(198, 209, 221, 0.5);
      // border-bottom: none;
    }

    /deep/.el-table__header th > .cell {
      font-weight: normal;
      font-size: 12px;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background-color: rgb(34, 45, 53);
      color: #ffffff;
      border-color: rgba(198, 209, 221, 0.5);
    }

    /deep/.el-table__body td.el-table-column--selection {
      background-color: rgb(65, 80, 90);
      color: #ffffff;
    }

    /deep/.el-table__body .cell.el-tooltip {
      font-size: 14px;
    }

    /deep/.el-table__fixed-right::before,
    /deep/.el-table__fixed::before {
      display: none;
    }

    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #222d35;
    }

    // 关于头部右侧空白
    /deep/.el-table__fixed-right-patch {
      background-color: rgb(65, 80, 90);
      border-bottom: none;
    }

    /deep/th.gutter {
      background-color: rgb(65, 80, 90);
    }
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);
      .searchLeft {
        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222d35;
          border-radius: 0;

          span {
            padding-left: 5px;
          }
        }
      }
      .searchRight {
        display: flex;
        justify-content: flex-end;
        .adminSearch {
          border-left: 1px solid #7b8395;
          display: flex;
          justify-content: flex-start;
          .searchAll {
            /deep/.el-input__inner {
              width: 220px;
              padding-left: 10px;
            }
          }

          .search-device {
            display: inline-block;
            line-height: 48px;
            padding: 0 15px;
            width: 100%;
            font-size: 14px;
            background: #202d35;
            color: #33ffb6;
            cursor: pointer;

            &:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }
          }

          .search-hide {
            display: inline-block;
            // position: absolute;
            // right: -58px;
            // line-height: 48px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 15px;
            font-size: 14px;
            background: #202d35;
            color: #7b8395;
            border-left: 1px solid #7b8395;
            cursor: pointer;

            &:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }
          }
        }
      }

      .statusName {
        padding: 0 16px;
        color: #adb9c0;
        font-size: 12px;
        line-height: 48px;
        font-weight: 700;
      }

      .statusList {
        cursor: pointer;
        padding: 0 16px;
        color: #70818c;
        font-size: 14px;
        height: 48px;
        line-height: 48px;
      }

      .active {
        color: #00febb;
        border-bottom: 2px solid #00febb;
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .batch-alert {
        height: 48px;
        line-height: 48px;
      }

      // 添加数采器
      .button-addscq {
        // width: 114px;
        height: 48px;
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        border-radius: 0px;
        border: none;
        cursor: pointer;

        span {
          font-size: 14px;
        }

        i {
          margin-left: 10px;
        }
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>
<style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    display: flex;
    align-items: center;
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.tablemain.el-table--border::after {
  display: none;
}

  .upload-contents {
        border-radius: 6px;
        border: 1px dashed rgba(255, 255, 255, 0.5);
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .upload-buttonEquipment {
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 6px 16px 6px 10px;
            color: rgba(255, 255, 255, 0.5);
            font-size: 14px;

            i {
                color: rgb(56, 165, 118);
                font-size: 32px;
            }
        }
    }

    .upload-input {
        display: none;
    }

    .uploadTips {
        margin: 10px auto;
        text-align: center;
    }
    .img-preview-dialog .el-dialog__header {
  display: none;
}
    .img-preview-dialog .el-dialog__body {
  padding: 0;
  background: #222;
}
</style>
